import { FC } from "react";
import "../styles/datev-button.css";

interface DatevButtonProps {
  children: string;
  loading: boolean;
  onClick: () => void;
}

const DatevButton: FC<DatevButtonProps> = ({ loading, onClick }) => {
  return (
    <button className="datev-btn" onClick={onClick}>
      <span>{loading ? "Laden..." : "Mit DATEV verbinden"}</span>
    </button>
  );
};

export default DatevButton;
